<template lang="pug">
.md-notification.col-xs-11.col-sm-3.alert.open(v-show='!hide'
    data-notify='container',
    :class='[placement.from, placement.align, `alert-${type}`, withIcon, position ? "small" : ""]',
    role='alert',
    :style='position || customPosition',
    data-notify-position='top-center'
  )
  button.close(v-if='allowDismiss', type='button', aria-hidden='true', data-notify='dismiss', @click='close')
    i.fal.fa-times
  //i.material-icons(data-notify='icon', v-if='!!icon') {{icon}}
  i.fas.alert-icon(:class='"fa-" + icon', v-if='!!icon')
  span(data-notify='title', v-if='!!heading')
    strong {{heading}}
    br
    br
  slot(name='message')
    span(data-notify='message', v-if='!!message', v-html='$t(message)')
    span(v-if='!!dismiss')
      br
    ed-button.btn.def(buttonClass='btn-actionbar' v-if='target !== "_blank" && goto' :href='goto || "#"' @click='close("")') {{ $t('Save a draft first') }}
    ed-button.btn(buttonClass='btn-actionbar' v-if='!!dismiss' :href='goto === null ? "#" + $route.fullPath : goto || "#"' @click.prevent='close(dismiss)') {{$t(dismiss)}}
    ed-button.btn.danger(buttonClass='btn-actionbar' v-if='goto === null || goto === ""' :href='goto === null ? "#" + $route.fullPath : goto === "" ? undefined : goto || "#"' @click='close(null)') {{$t(discard)}}
    //br
    //em(v-if='!!target && goto') {{dismiss}}, but &nbsp;
  .progress(data-notify='progressbar', v-if='progressbar')
    .progress-bar(class='`progress-bar-${type}`', role='progressbar', aria-valuenow='0', aria-valuemin='0', aria-valuemax='100', style='width: 0%;')
  a(v-if='!!url', href='url', target='target', data-notify='url')
</template>
<script>
const EVENT_ON_CLOSE = 'onClose'

export default {
  name: 'md-notification',
  props: {
    type: {
      type: String,
      default: 'info',
      validator: val => ['', 'plain', 'primary', 'info', 'success', 'warning', 'danger'].indexOf(val) !== -1
    },
    icon: String,
    title: String,
    heading: String,
    message: String,
    dismiss: String,
    discard: { type: String, default: 'Discard' },
    allowDismiss: {
      type: Boolean,
      default: true
    },
    progressbar: {
      type: Object
    },
    url: String,
    goto: String,
    target: {
      type: String,
      default: '_blank',
      validator: val => {
        const targets = ['', '_self', '_blank']
        return targets.indexOf(val) !== -1
      }
    },
    width: {
      type: Number,
      default: 350
    },
    position: Object,
    placement: {
      type: Object,
      default: () => {
        return {
          from: 'top',
          align: 'right'
        }
      },
      validator: plmt => {
        const froms = ['top', 'bottom']
        const aligns = ['left', 'center', 'right']
        return froms.indexOf(plmt.from) !== -1 && aligns.indexOf(plmt.align) !== -1
      }
    },
    timeout: {
      type: Number,
      default: 5000
    },
    hide: Boolean
  },
  data() {
    return {}
  },
  computed: {
    withIcon() {
      return (this.icon && this.icon.length > 0) ? 'alert-with-icon' : ''
    },
    customPosition() {
      let initialMargin = 20
      let alertHeight = 90
      let sameAlertsCount = this.$notifications.state.filter((alert) => {
        return alert.placement && alert.placement.align === this.placement.align && alert.placement.from === this.placement.from
      }).length
      let pixels = (sameAlertsCount - 1) * alertHeight + initialMargin
      let styles = {}
      if (this.placement.from === 'top') {
        styles.top = `${pixels}px`
      } else {
        styles.bottom = `${pixels}px`
      }
      styles.width = `${this.width}px`
      return styles
    }
  },
  methods: {
    close(forceDismiss) {
      if (forceDismiss && forceDismiss.target && this.type !== 'info') {
        this.$router.replace(this.currentPath)
      }
      this.$emit(EVENT_ON_CLOSE, forceDismiss)
    }
  },
  created() {
    this.currentPath = this.$route.fullPath
  },
  mounted() {
    if (this.timeout) {
      setTimeout(this.close, this.timeout)
    }
  }
}
</script>
<style lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "../../../assets/sass/md/variables";

.fade-enter-active,
.fade-leave-active {
  transition: opacity .3s
}

.fade-enter,
.fade-leave-to {
  opacity: 0
}

.md-notification {
  &.alert {
    border: 0;
    border-radius: 0;
    color: $white;
    padding: 10px 15px;
    font-size: 14px;
    z-index: 100;
    display: inline-block;
    position: fixed;
    transition: all 0.5s ease-in-out;
    min-height: 4em;

    &.center {
      left: 0px;
      right: 0px;
      margin: 0 auto;
    }
    &.left {
      left: 20px;
    }
    &.right {
      right: 20px;
    }
    .container & {
      border-radius: 4px;
    }
    .navbar & {
      border-radius: 0;
      left: 0;
      position: absolute;
      right: 0;
      top: 85px;
      width: 100%;
      z-index: 3;
    }
    .navbar:not(.navbar-transparent) & {
      top: 70px;
    }

    .alert-icon {
      font-size: 30px;
      margin-right: 5px;
      position: absolute;
      margin-left: -45px;
      margin-top: 5px;
      color: $urgent-01;
    }

    .btn.btn.btn-actionbar[class] {
      background-color: $canvas;
      border: 1px solid $background;
      color: $ink;

      &:hover {
        color: $ink;
        border-color: $border;
      }

      &.def {
        background-color: lighten($urgent-01, 20%);
      }
    }

    .close i {
      font-size: $font-size-base;
    }
    .close~span {
      display: block;
      max-width: 89%;
    }

    [data-notify="message"] {
      word-break: break-word;
    }

    &[data-notify="container"] {
      width: 350px;
      padding: 10px 10px 10px 20px;
      border-radius: $border-radius-base;
    }

    &.alert-with-icon {
      padding-left: 65px;
    }
  }

  &.small {
    transition: none;
    margin-top: -3px;
    min-height: 0;
    p {
      font-size: $font-size-base-sm;
      margin-bottom: 0;
    }

    &:after, &:before {
      right: 100%;
      top: 50%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    &:after {
      border-color: rgba(136, 183, 213, 0);
      border-right-color: $canvas;
      border-width: 10px;
      margin-top: -10px;
    }
    &:before {
      border-color: rgba(194, 225, 245, 0);
      border-right-color: $urgent-01;
      border-width: 11px;
      margin-top: -11px;
    }
  }

  &.alert-plain {
    background-color: #fff;
    border: 1px solid $urgent-01;
    color: $ink;
  }

  &.alert-info, &.alert-info-warn, &.alert-info-danger {
    background-color: $canvas;
    border: 1px solid $background-light;
    box-shadow: $box-shadow;
    &.alert[data-notify] {
      border-radius: $border-radius-large;
      width: 550px;
      min-height: 3em;
      margin-top: 75px;
    }
    &, .close {
      color: $ink;
    }
    .close {
      margin-top: 0.25em;
    }
    &-warn {
      border-color: $brand-warning;
    }
    &-danger {
      border-color: $brand-danger;
    }
  }

  &.alert-success {
    //background-color: $brand-success;
    border: 1px solid $brand-success;
    color: $ink;
  }

  &.alert-warning {
    //background-color: $brand-warning;
    border: 1px solid $brand-warning;
    color: $ink;
  }

  &.alert-danger {
    //background-color: $brand-danger;
    border: 1px solid $brand-danger;
    color: $ink;
  }
}
</style>



// WEBPACK FOOTER //
// src/core/components/mdNotification/index.vue